import { z } from "zod";

export const TTaskSettings = z.object({
  checklistRequired: z.boolean(),
  checklistFieldsRequired: z.boolean(),
  attachmentRequired: z.boolean(),
  commentRequired: z.boolean(),
});
export type ITaskSettings = z.infer<typeof TTaskSettings>;
